const InfoHeader = ({ children, show, backgroundColor, ariaLabel }) => {
	if (show === false) {
		return null
	}

	return (
		<aside role="complementary" aria-label={ariaLabel} className="p-3 p-lg-5 f2  color-fg-white f-second" style={{ backgroundColor: backgroundColor }}>
			{children}
		</aside>
	)
}

export { InfoHeader }
